import React from 'react';
import { useTranslation } from 'react-i18next';
import './languageSelector.scss';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const currentLang = (i18n.resolvedLanguage || i18n.language || 'es').startsWith('en') ? 'en' : 'es';

  const handleLanguageChange = (lang) => {
    if (lang !== currentLang) {
      i18n.changeLanguage(lang);
    }
  };

  return (
    <div className="language-selector" aria-label="Language selector">
      <button
        type="button"
        className={`lang-btn ${currentLang === 'es' ? 'active' : ''}`}
        onClick={() => handleLanguageChange('es')}
        aria-label="Español"
      >
        ES
      </button>
      <span className="lang-divider">|</span>
      <button
        type="button"
        className={`lang-btn ${currentLang === 'en' ? 'active' : ''}`}
        onClick={() => handleLanguageChange('en')}
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSelector;
